import { writable } from "../utils/stores";
export class LocalStorageStore {
    #key;
    #serialise;
    #deserialise;
    #store;
    get value() {
        return this.#store.value;
    }
    get dirty() {
        return this.#store.dirty;
    }
    subscribe = (start, invalidate) => this.#store.subscribe(start, invalidate);
    update(fn) {
        this.#store.update(val => {
            const updated = fn(val);
            this.#write(updated);
            return updated;
        });
    }
    #write(val) {
        if (val === undefined) {
            localStorage.removeItem(this.#key);
        }
        else {
            localStorage.setItem(this.#key, this.#serialise(val));
        }
    }
    constructor(key, defVal, serialiser, deserialiser, eq) {
        this.#key = key;
        this.#serialise = serialiser ?? ((v) => v);
        this.#deserialise = deserialiser ?? ((v) => v);
        const val = localStorage.getItem(this.#key);
        if (val != null) {
            this.#store = writable(this.#deserialise(val), undefined, eq);
        }
        else {
            this.#store = writable(defVal, undefined, eq);
        }
    }
    set(val) {
        this.#write(val);
        this.#store.set(val);
    }
    // Update the in-memory value without touching localStorage. For use where a value changes
    // rapidly (e.g. while dragging) - call `persist` once the value has settled.
    setTransient(val) {
        this.#store.set(val);
    }
    persist() {
        this.#write(this.#store.value);
    }
}
export class LocalStorageBoolStore extends LocalStorageStore {
    constructor(key, defVal) {
        super(key, defVal, (b) => b.toString(), (b) => b === "true");
    }
    toggle = () => {
        this.set(!this.value);
    };
}
